import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const FIREBREAKTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FirebreakType.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.FirebreakType.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const FIREBREAKTYPE_CONFIG = {
  entityName: 'FirebreakType',
  localizationKey: 'Planning::Entity.FirebreakType',
  fields: FIREBREAKTYPE_FIELDS,
  permission: 'PlanningLocation.FirebreakTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
